import { Navigate } from "react-router-dom";

const RedirectAuth = ({ isLoggedIn, children }) => {
    if (isLoggedIn) {
        return <Navigate to={"/"} replace />;
    }
    return children;
};
export default RedirectAuth;